import styles from './FilterPage.module.scss'
import TravelFilterNav from '@/components/models/travel/filter/TravelFilterNav'
import TravelFilterResultList from '@/components/models/travel/filter/TravelFilterResultList'
import { Container } from 'react-bootstrap'
import { TravelFilterTravel } from '@/features/travelFilter/types'

interface Props {
  initialTravels?: TravelFilterTravel[]
}
const TravelFilterPage = ({ initialTravels }: Props) => {
  return (
    <>
      <Container fluid className={`${styles.root} py-3 shadow-lg`}>
        <TravelFilterNav />
      </Container>
      <TravelFilterResultList travels={initialTravels} className={'mt-5 mb-4'} trackingStringPrefix={'travel_filter:filter'} />
    </>
  )
}

export default TravelFilterPage
